package br.com.htms.inspeccaocampo.ui.screens

import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.FilterChip
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import br.com.htms.inspeccaocampo.auth.AccessLogEntry
import br.com.htms.inspeccaocampo.data.logs.resumoDetalheLog
import br.com.htms.inspeccaocampo.data.logs.tamanhoLog
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.auth.AuthUserListItem
import br.com.htms.inspeccaocampo.data.FormTipo
import br.com.htms.inspeccaocampo.platform.PlatformFiles
import br.com.htms.inspeccaocampo.platform.formatDateTimeBr
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import kotlinx.coroutines.delay
import kotlinx.coroutines.isActive
import kotlinx.coroutines.launch

private enum class AccessLogFiltro(val rotulo: String) {
    TODOS("Todos"),
    ENVIOS("Envios"),
    FALHAS("Falhas"),
    LOGINS("Logins"),
    REM("REM"),
    ADMIN("Admin")
}

private enum class AccessLogStatus {
    OK, FAIL, START_OK_SERVER, START_PENDING, NEUTRAL
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SharedAccessLogPanel(onMessage: (String) -> Unit) {
    var aberto by remember { mutableStateOf(false) }
    var logs by remember { mutableStateOf<List<AccessLogEntry>>(emptyList()) }
    var loading by remember { mutableStateOf(false) }
    var loadedOnce by remember { mutableStateOf(false) }
    var filtro by remember { mutableStateOf(AccessLogFiltro.TODOS) }
    var filtroUser by remember { mutableStateOf("") }
    var users by remember { mutableStateOf<List<AuthUserListItem>>(emptyList()) }
    var userMenu by remember { mutableStateOf(false) }
    var filtroFrom by remember { mutableStateOf("") }
    var filtroTo by remember { mutableStateOf("") }
    val scope = rememberCoroutineScope()

    fun parseDiaMs(raw: String, endOfDay: Boolean): Long? {
        val t = raw.trim()
        if (t.isEmpty()) return null
        val parts = t.split("/", "-", ".")
        if (parts.size != 3) return null
        val d = parts[0].toIntOrNull() ?: return null
        val m = parts[1].toIntOrNull() ?: return null
        val y = parts[2].toIntOrNull() ?: return null
        if (y < 2000 || m !in 1..12 || d !in 1..31) return null
        // Epoch aproximado UTC (suficiente para filtro admin).
        val dayStart = javaEpochDays(y, m, d) * 86_400_000L
        return if (endOfDay) dayStart + 86_400_000L - 1L else dayStart
    }

    fun carregarUsuarios() {
        scope.launch {
            AuthApi.listUsers()
                .onSuccess { list ->
                    users = list
                        .filter { !it.username.equals("admin", ignoreCase = true) }
                        .sortedBy { it.username.lowercase() }
                }
                .onFailure { /* lista opcional; filtros de data ainda funcionam */ }
        }
    }

    fun recarregar() {
        scope.launch {
            loading = true
            AuthApi.listAccessLogs(
                limit = 2000,
                action = null,
                user = filtroUser.trim().takeIf { it.isNotEmpty() },
                q = null,
                fromMs = parseDiaMs(filtroFrom, endOfDay = false),
                toMs = parseDiaMs(filtroTo, endOfDay = true)
            )
                .onSuccess {
                    logs = it
                    loadedOnce = true
                }
                .onFailure {
                    loadedOnce = true
                    onMessage(it.message ?: "Falha ao carregar log de acesso")
                }
            loading = false
        }
    }

    fun exportarCsv() {
        val rows = when (filtro) {
            AccessLogFiltro.TODOS -> logs
            else -> filterByChip(logs, filtro)
        }
        if (rows.isEmpty()) {
            onMessage("Nada para exportar neste filtro.")
            return
        }
        runCatching {
            val csv = buildString {
                appendLine("createdAt;actorUsername;action;target;detail;ip")
                rows.forEach { e ->
                    append(
                        listOf(
                            formatDateTimeBr(e.createdAt),
                            e.actorUsername.orEmpty(),
                            e.action,
                            e.target.orEmpty(),
                            e.detail.orEmpty(),
                            e.ip.orEmpty()
                        ).joinToString(";") { csvEscape(it) }
                    )
                    appendLine()
                }
            }
            val path = PlatformFiles.join(PlatformFiles.cacheDir(), "access-logs.csv")
            PlatformFiles.writeText(path, csv)
            br.com.htms.inspeccaocampo.platform.BackupSharePoint.com("Logs", "Log de acesso") { PlatformFiles.shareFile(path, "text/csv", "Log de acesso") }
            onMessage("CSV exportado (${rows.size} linhas).")
        }.onFailure {
            onMessage(it.message ?: "Falha ao exportar CSV")
        }
    }

    LaunchedEffect(aberto, filtroFrom, filtroTo, filtroUser) {
        if (!aberto) return@LaunchedEffect
        if (users.isEmpty()) carregarUsuarios()
        while (isActive) {
            recarregar()
            delay(20_000)
        }
    }

    val filtroUserLabel = remember(filtroUser) {
        if (filtroUser.isBlank()) "Todos" else filtroUser
    }

    val uploadedLocalIds = remember(logs) {
        logs.asSequence()
            .filter { it.action == "INSPECTION_UPLOAD" }
            .mapNotNull { extractLocalId(it.detail) }
            .toSet()
    }

    val filtrados = remember(logs, filtro, uploadedLocalIds) {
        filterByChip(logs, filtro, uploadedLocalIds)
    }

    Card(
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant),
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(
            Modifier.padding(12.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            PortalOutlinedButton(
                onClick = { aberto = true },
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(
                    if (loadedOnce) "Log de acesso (${logs.size})" else "Log de acesso"
                )
            }
            Text(
                "Logins, envios, e-mail, REM, fotos e gestão — toque para abrir.",
                style = MaterialTheme.typography.bodySmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
        }
    }

    if (aberto) {
        Dialog(
            onDismissRequest = { aberto = false },
            properties = DialogProperties(
                usePlatformDefaultWidth = false,
                dismissOnBackPress = true,
                dismissOnClickOutside = true
            )
        ) {
            Box(modifier = Modifier.fillMaxSize()) {
                Box(
                    modifier = Modifier
                        .fillMaxSize()
                        .background(Color.Black.copy(alpha = 0.45f))
                        .clickable(
                            interactionSource = remember { MutableInteractionSource() },
                            indication = null,
                            onClick = { aberto = false }
                        )
                )
                Card(
                    modifier = Modifier
                        .align(Alignment.Center)
                        .padding(horizontal = 16.dp, vertical = 20.dp)
                        .widthIn(max = 900.dp)
                        .fillMaxWidth()
                        .fillMaxHeight(0.9f),
                    shape = RoundedCornerShape(16.dp),
                    colors = CardDefaults.cardColors(
                        containerColor = MaterialTheme.colorScheme.surface
                    ), border = PortalCores.BordaCartao,
                    elevation = CardDefaults.cardElevation(defaultElevation = 8.dp)
                ) {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .padding(16.dp),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Text(
                                "Log de acesso",
                                style = MaterialTheme.typography.titleLarge,
                                fontWeight = FontWeight.Bold,
                                modifier = Modifier.weight(1f),
                                color = PortalCores.Navy
                            )
                            TextButton(onClick = { aberto = false }) {
                                Text("✕")
                            }
                        }
                        Text(
                            "Filtros no servidor (usuário e datas dd/mm/aaaa). Exporta o que está carregado.",
                            style = MaterialTheme.typography.bodySmall,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                        br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                            label = "Usuário",
                            opcoes = listOf("" to "Todos") + users.map { it.username to it.username },
                            selecionado = filtroUser,
                            onSelect = { filtroUser = it }
                        )
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.spacedBy(6.dp)
                        ) {
                            AppOutlinedTextField(
                                value = filtroFrom,
                                onValueChange = { filtroFrom = it },
                                label = { Text("De (dd/mm/aaaa)") },
                                singleLine = true,
                                modifier = Modifier.weight(1f)
                            )
                            AppOutlinedTextField(
                                value = filtroTo,
                                onValueChange = { filtroTo = it },
                                label = { Text("Até (dd/mm/aaaa)") },
                                singleLine = true,
                                modifier = Modifier.weight(1f)
                            )
                        }
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.SpaceBetween,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Text(
                                if (loading) {
                                    "Carregando..."
                                } else {
                                    "Exibindo ${filtrados.size} de ${logs.size}"
                                },
                                fontWeight = FontWeight.SemiBold
                            )
                            Row(horizontalArrangement = Arrangement.spacedBy(4.dp)) {
                                TextButton(onClick = { exportarCsv() }, enabled = !loading && logs.isNotEmpty()) {
                                    Text("CSV")
                                }
                                TextButton(onClick = { recarregar() }, enabled = !loading) {
                                    Text("Atualizar")
                                }
                            }
                        }
                        Row(
                            modifier = Modifier.fillMaxWidth(),
                            horizontalArrangement = Arrangement.spacedBy(6.dp)
                        ) {
                            AccessLogFiltro.entries.forEach { opcao ->
                                FilterChip(
                                    selected = filtro == opcao,
                                    onClick = { filtro = opcao },
                                    label = { Text(opcao.rotulo) }
                                )
                            }
                        }
                        val rolagem333 = androidx.compose.foundation.rememberScrollState()
                        br.com.htms.inspeccaocampo.ui.kit.AreaRolavel(rolagem333, Modifier
                                .fillMaxWidth()
                                .weight(1f)) {
                        Column(
                            modifier = Modifier.fillMaxSize().verticalScroll(rolagem333),
                            verticalArrangement = Arrangement.spacedBy(4.dp)
                        ) {
                            filtrados.forEach { entry ->
                                AccessLogEntryCard(entry = entry, uploadedLocalIds = uploadedLocalIds)
                            }
                            if (!loading && filtrados.isEmpty() && loadedOnce) {
                                Text(
                                    if (logs.isEmpty()) "Nenhum evento registrado."
                                    else "Nenhum evento neste filtro.",
                                    style = MaterialTheme.typography.bodySmall
                                )
                            }
                        }
                        }
                        PortalButton(
                            onClick = { aberto = false },
                            modifier = Modifier.fillMaxWidth()
                        ) {
                            Text("Fechar")
                        }
                    }
                }
            }
        }
    }
}

private fun filterByChip(
    logs: List<AccessLogEntry>,
    filtro: AccessLogFiltro,
    uploadedLocalIds: Set<String> = emptySet()
): List<AccessLogEntry> = logs.filter { entry ->
    when (filtro) {
        AccessLogFiltro.TODOS -> true
        AccessLogFiltro.ENVIOS ->
            entry.action == "FORM_SEND" ||
                entry.action == "FORM_SAVE" ||
                entry.action == "INSPECTION_UPLOAD" ||
                entry.action == "EMAIL_OK" ||
                entry.action == "PHOTO_UPLOAD"
        AccessLogFiltro.FALHAS ->
            entry.action == "LOGIN_FAIL" ||
                entry.action == "LOGIN_BLOCKED" ||
                entry.action == "FORM_SAVE_FAIL" ||
                entry.action == "EMAIL_FAIL" ||
                entry.action == "PHOTO_UPLOAD_FAIL" ||
                entry.action == "PHOTO_CAPTURE_FAIL" ||
                entry.action == "INSPECTION_UPLOAD_FAIL" ||
                entry.action == "AUTH_DENIED" ||
                (entry.action == "FORM_SEND" && entry.detail?.contains("result=fail") == true) ||
                (
                    entry.action == "FORM_SEND" &&
                        entry.detail?.contains("result=start") == true &&
                        extractLocalId(entry.detail)?.let { it !in uploadedLocalIds } == true
                    )
        AccessLogFiltro.LOGINS ->
            entry.action.startsWith("LOGIN_") || entry.action == "LOGOUT" || entry.action == "AUTH_DENIED"
        AccessLogFiltro.REM ->
            entry.action.startsWith("REM_")
        AccessLogFiltro.ADMIN ->
            entry.action.startsWith("USER_") ||
                entry.action.startsWith("OBRA_") ||
                entry.action == "INSPECTION_DELETE" ||
                entry.action == "INSPECTION_TRASH" ||
                entry.action == "INSPECTION_PURGE" ||
                entry.action == "INSPECTION_RESTORE" ||
                entry.action.endsWith("_TRASH") ||
                entry.action.endsWith("_PURGE") ||
                entry.action.endsWith("_RESTORE") ||
                entry.action == "app_config_update" ||
                entry.action == "REM_RESET"
    }
}

/** Dias desde epoch UTC (algoritmo civil Gregorian). */
private fun javaEpochDays(year: Int, month: Int, day: Int): Long {
    var y = year.toLong()
    var m = month.toLong()
    if (m <= 2) {
        y -= 1
        m += 12
    }
    val era = if (y >= 0) y / 400 else (y - 399) / 400
    val yoe = y - era * 400
    val doy = (153 * (m - 3) + 2) / 5 + day - 1
    val doe = yoe * 365 + yoe / 4 - yoe / 100 + doy
    return era * 146097 + doe - 719468
}

private fun csvEscape(value: String): String {
    val needsQuote = value.contains(';') || value.contains('"') || value.contains('\n') || value.contains('\r')
    val escaped = value.replace("\"", "\"\"")
    return if (needsQuote) "\"$escaped\"" else escaped
}

@Composable
private fun AccessLogEntryCard(
    entry: AccessLogEntry,
    uploadedLocalIds: Set<String>
) {
    var expand by remember(entry.id) { mutableStateOf(false) }
    val status = resolveStatus(entry, uploadedLocalIds)
    val statusColor = statusColor(status)
    val statusLabel = statusLabel(status)
    val formRotulo = formRotuloDe(entry)
    val command = extractParam(entry.detail, "command")
    val localId = extractLocalId(entry.detail)
    val remoteId = extractParam(entry.detail, "remoteId")
    val obra = extractParam(entry.detail, "obra")
    val local = extractParam(entry.detail, "local")
    val tst = extractParam(entry.detail, "tst")
    val nome = extractParam(entry.detail, "nome")
    val role = extractParam(entry.detail, "role")
    val error = extractParam(entry.detail, "error")
    val pendencias = extractParam(entry.detail, "pendencias")
    val platform = extractParam(entry.detail, "platform")
    val appVer = extractParam(entry.detail, "appVer")
    val bytes = extractParam(entry.detail, "bytes")
    val emailTo = extractParam(entry.detail, "to")
        ?: extractParam(entry.detail, "email")
    val resumoAcao = resumoAcao(entry, uploadedLocalIds)
    val detailFull = entry.detail.orEmpty()
    val actionLabel = accessLogActionLabel(entry.action, entry.detail)
    val userShort = entry.actorUsername ?: "—"
    val summaryBits = buildList {
        if (resumoAcao.isNotBlank()) add(resumoAcao)
        if (formRotulo.isNotBlank()) add(formRotulo)
        obra?.takeIf { it.isNotBlank() }?.let { add(it) }
        if (!error.isNullOrBlank()) add("Erro: $error")
    }
    val summaryLine = summaryBits.joinToString(" · ")
    val hasExtra = formRotulo.isNotBlank() ||
        role != null || nome != null ||
        platform != null || appVer != null ||
        localId != null || remoteId != null ||
        command != null || obra != null || local != null ||
        tst != null || pendencias != null || bytes != null ||
        emailTo != null || !error.isNullOrBlank() ||
        !entry.ip.isNullOrBlank() || detailFull.isNotBlank() ||
        entry.target?.isNotBlank() == true

    Card(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(
                interactionSource = remember { MutableInteractionSource() },
                indication = null,
                onClick = { if (hasExtra) expand = !expand }
            ),
        colors = CardDefaults.cardColors(
            containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.35f)
        ),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp),
        shape = RoundedCornerShape(8.dp)
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 8.dp, vertical = 5.dp),
            verticalArrangement = Arrangement.spacedBy(2.dp)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(6.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                StatusChip(label = statusLabel, color = statusColor)
                Text(
                    actionLabel,
                    style = MaterialTheme.typography.labelMedium,
                    fontWeight = FontWeight.SemiBold,
                    modifier = Modifier.weight(1f),
                    maxLines = 1
                )
                Text(
                    userShort,
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    maxLines = 1
                )
                Text(
                    formatDateTimeBr(entry.createdAt),
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    maxLines = 1
                )
            }
            if (summaryLine.isNotBlank()) {
                Text(
                    summaryLine,
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onSurface,
                    maxLines = if (expand) Int.MAX_VALUE else 1
                )
            }
            if (expand && hasExtra) {
                if (formRotulo.isNotBlank()) {
                    LogLine(rotulo = "Form", valor = formRotulo)
                }
                LogLine(
                    rotulo = "Usuário",
                    valor = buildString {
                        append(userShort)
                        role?.takeIf { it.isNotBlank() }?.let { append(" · $it") }
                        nome?.takeIf { it.isNotBlank() }?.let { append(" · $it") }
                        entry.target?.takeIf {
                            it.isNotBlank() &&
                                it != extractParam(entry.detail, "formId") &&
                                FormTipo.fromId(it).id != it &&
                                !it.equals(formRotulo, ignoreCase = true)
                        }?.let { append(" · alvo $it") }
                    }
                )
                if (platform != null || appVer != null) {
                    LogLine(
                        rotulo = "Cliente",
                        valor = buildString {
                            platform?.let { append(it) }
                            if (platform != null && appVer != null) append(" · ")
                            appVer?.let { append("v$it") }
                        }
                    )
                }
                if (localId != null || remoteId != null) {
                    LogLine(
                        rotulo = "IDs",
                        valor = buildString {
                            localId?.let { append("local $it") }
                            if (localId != null && remoteId != null) append(" · ")
                            remoteId?.let { append("remote $it") }
                        }
                    )
                }
                command?.let { LogLine(rotulo = "Cmd", valor = commandRotulo(it)) }
                obra?.let { LogLine(rotulo = "Obra", valor = it) }
                local?.let { LogLine(rotulo = "Local", valor = it) }
                tst?.let { LogLine(rotulo = "TST", valor = it) }
                pendencias?.let { LogLine(rotulo = "Pendências", valor = it) }
                bytes?.let { LogLine(rotulo = "Tamanho", valor = it.toLongOrNull()?.let(::tamanhoLog) ?: it) }
                emailTo?.let { LogLine(rotulo = "E-mail", valor = it) }
                if (!error.isNullOrBlank()) {
                    Text(
                        "Erro: $error",
                        style = MaterialTheme.typography.labelSmall,
                        color = MaterialTheme.colorScheme.error
                    )
                }
                entry.ip?.takeIf { it.isNotBlank() }?.let { ip ->
                    LogLine(rotulo = "IP", valor = ip)
                }
                val legivel = resumoDetalheLog("", detailFull)
                if (legivel.isNotBlank() && !detailFull.contains("=")) {
                    LogLine(rotulo = "Detalhe", valor = detailFull)
                } else if (legivel.isBlank() && detailFull.isNotBlank() && !detailFull.contains("ua=")) {
                    LogLine(rotulo = "Detalhe", valor = detailFull)
                }
            } else if (hasExtra) {
                Text(
                    "Toque para detalhes",
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.primary.copy(alpha = 0.75f)
                )
            }
        }
    }
}

@Composable
private fun LogLine(rotulo: String, valor: String) {
    if (valor.isBlank()) return
    Text(
        "$rotulo: $valor",
        style = MaterialTheme.typography.labelSmall,
        color = MaterialTheme.colorScheme.onSurface
    )
}

@Composable
private fun StatusChip(label: String, color: Color) {
    Box(
        modifier = Modifier
            .background(color.copy(alpha = 0.14f), RoundedCornerShape(4.dp))
            .padding(horizontal = 5.dp, vertical = 1.dp)
    ) {
        Text(
            label,
            style = MaterialTheme.typography.labelSmall,
            fontWeight = FontWeight.SemiBold,
            color = color
        )
    }
}

@Composable
private fun statusColor(status: AccessLogStatus): Color = when (status) {
    AccessLogStatus.OK, AccessLogStatus.START_OK_SERVER ->
        Color(0xFF2E7D32)
    AccessLogStatus.FAIL ->
        MaterialTheme.colorScheme.error
    AccessLogStatus.START_PENDING ->
        Color(0xFFED6C02)
    AccessLogStatus.NEUTRAL ->
        MaterialTheme.colorScheme.onSurfaceVariant
}

private fun statusLabel(status: AccessLogStatus): String = when (status) {
    AccessLogStatus.OK -> "OK"
    AccessLogStatus.FAIL -> "FALHOU"
    AccessLogStatus.START_OK_SERVER -> "NO SERVIDOR"
    AccessLogStatus.START_PENDING -> "INCOMPLETO"
    AccessLogStatus.NEUTRAL -> "INFO"
}

private fun resolveStatus(
    entry: AccessLogEntry,
    uploadedLocalIds: Set<String>
): AccessLogStatus {
    val detail = entry.detail.orEmpty()
    return when (entry.action) {
        "LOGIN_OK", "USER_CREATE", "USER_UPDATE", "INSPECTION_UPLOAD", "app_config_update",
        "FORM_SAVE", "EMAIL_OK", "PHOTO_UPLOAD", "REM_SAVE", "REM_EXCEL_DOWNLOAD",
        "REL_SEG_SAVE", "REL_SEG_PPTX_DOWNLOAD",
        "OBRA_CREATE", "OBRA_UPDATE" ->
            AccessLogStatus.OK
        "MANUAL_OPEN", "LOGOUT", "REM_OPEN", "USER_DELETE", "INSPECTION_DELETE", "REM_RESET",
        "REL_SEG_DELETE", "REM_TRASH", "ACOMP_AMB_TRASH", "REL_SEG_TRASH", "INSPECTION_TRASH",
        "REM_RESTORE", "ACOMP_AMB_RESTORE", "REL_SEG_RESTORE", "INSPECTION_RESTORE",
        "REM_PURGE", "ACOMP_AMB_PURGE", "REL_SEG_PURGE", "INSPECTION_PURGE" ->
            AccessLogStatus.NEUTRAL
        "LOGIN_FAIL", "LOGIN_BLOCKED", "FORM_SAVE_FAIL", "EMAIL_FAIL",
        "PHOTO_UPLOAD_FAIL", "PHOTO_CAPTURE_FAIL", "INSPECTION_UPLOAD_FAIL", "AUTH_DENIED" ->
            AccessLogStatus.FAIL
        "FORM_SEND" -> when {
            detail.contains("result=ok") -> AccessLogStatus.OK
            detail.contains("result=fail") -> AccessLogStatus.FAIL
            detail.contains("result=start") -> {
                val lid = extractLocalId(detail)
                if (lid != null && lid in uploadedLocalIds) AccessLogStatus.START_OK_SERVER
                else AccessLogStatus.START_PENDING
            }
            else -> AccessLogStatus.NEUTRAL
        }
        else -> AccessLogStatus.NEUTRAL
    }
}

private fun formRotuloDe(entry: AccessLogEntry): String {
    val doDetail = extractParam(entry.detail, "form")
    if (!doDetail.isNullOrBlank()) return doDetail
    val formId = extractParam(entry.detail, "formId") ?: entry.target
    if (formId.isNullOrBlank()) return ""
    return FormTipo.entries.find { it.id.equals(formId, ignoreCase = true) }?.rotulo.orEmpty()
}

private fun commandRotulo(command: String): String = when (command.lowercase()) {
    "abrir" -> "abrir"
    "editar" -> "editar"
    "salvar" -> "salvar"
    "enviar" -> "enviar"
    "manual" -> "abrir manual"
    "sair" -> "sair"
    else -> command
}

private fun resumoAcao(
    entry: AccessLogEntry,
    uploadedLocalIds: Set<String>
): String {
    val detail = entry.detail.orEmpty()
    return when (entry.action) {
        "FORM_SEND" -> when {
            detail.contains("result=ok") -> buildString {
                append("Envio confirmado")
                if (detail.contains("recovered=")) append(" (recuperado)")
                if (detail.contains("retry=1")) append(" · reenvio")
            }
            detail.contains("result=fail") -> "Falha no envio"
            detail.contains("result=start") -> {
                val lid = extractLocalId(detail)
                if (lid != null && lid in uploadedLocalIds) {
                    "Iniciado no app; servidor já confirmou recebimento"
                } else {
                    "Iniciado no app; sem confirmação no servidor"
                }
            }
            detail.contains("result=requeue") -> "Reenfileirado para reenvio"
            else -> ""
        }
        "FORM_SAVE" -> "Salvo localmente"
        "FORM_SAVE_FAIL" -> "Clicou em salvar, mas havia pendências"
        "INSPECTION_UPLOAD" -> buildString {
            append("Gravado no servidor")
            if (detail.contains("pdf=1")) append(" · PDF")
            if (detail.contains("excel=1")) append(" · Excel")
        }
        "FORM_OPEN", "CHECKLIST_OPEN" -> "Abertura do formulário"
        "MANUAL_OPEN" -> "Abriu o manual do formulário"
        "LOGOUT" -> "Saiu da sessão"
        "EMAIL_OK" -> "E-mail enviado"
        "EMAIL_FAIL" -> "Falha no e-mail"
        "REM_SAVE" -> "REM salvo"
        "REM_EXCEL_DOWNLOAD" -> "Download Excel REM"
        "REM_RESET" -> "Reset REM"
        "REM_OPEN" -> "Abriu REM"
        "REL_SEG_SAVE" -> "Rel. Seg. salvo"
        "REL_SEG_PPTX_DOWNLOAD" -> "Download PPTX Rel. Seg."
        "REL_SEG_DELETE" -> "Rel. Seg. excluído"
        "REM_TRASH" -> "REM → lixeira"
        "ACOMP_AMB_TRASH" -> "Acomp. Amb. → lixeira"
        "REL_SEG_TRASH" -> "Rel. Seg. → lixeira"
        "INSPECTION_TRASH" -> "Inspeção → lixeira"
        "REM_RESTORE", "ACOMP_AMB_RESTORE", "REL_SEG_RESTORE", "INSPECTION_RESTORE" -> "Recuperado da lixeira"
        "REM_PURGE", "ACOMP_AMB_PURGE", "REL_SEG_PURGE", "INSPECTION_PURGE" -> "Apagado da lixeira"
        "PHOTO_UPLOAD" -> resumoDetalheLog("", detail).ifBlank { "Foto enviada" }
        "PHOTO_UPLOAD_FAIL", "PHOTO_CAPTURE_FAIL" -> resumoDetalheLog("", detail).ifBlank { "Falha na foto" }
        "INSPECTION_DELETE" -> "Inspeção removida"
        "INSPECTION_UPLOAD_FAIL" -> "Falha no upload da inspeção"
        "OBRA_CREATE" -> "Obra criada"
        "OBRA_UPDATE" -> "Obra atualizada"
        "AUTH_DENIED" -> "Acesso negado"
        else -> ""
    }
}

private fun extractLocalId(detail: String?): String? = extractParam(detail, "localId")

private fun extractParam(detail: String?, key: String): String? {
    if (detail.isNullOrBlank()) return null
    val token = "$key="
    val start = detail.indexOf(token)
    if (start < 0) return null
    val from = start + token.length
    val end = detail.indexOf(';', from).let { if (it < 0) detail.length else it }
    return detail.substring(from, end).trim().takeIf { it.isNotEmpty() }
}

private fun accessLogActionLabel(action: String, detail: String? = null): String = when (action) {
    "LOGIN_OK" -> "Login OK"
    "LOGIN_FAIL" -> "Login falhou"
    "LOGIN_BLOCKED" -> "Login bloqueado"
    "LOGOUT" -> "Logout"
    "USER_CREATE" -> "Usuário criado"
    "USER_UPDATE" -> "Usuário atualizado"
    "USER_DELETE" -> "Usuário removido"
    "FORM_OPEN" -> "Abriu formulário"
    "CHECKLIST_OPEN" -> "Abriu checklist"
    "MANUAL_OPEN" -> "Abriu o manual"
    "FORM_SAVE" -> "Salvou formulário"
    "FORM_SAVE_FAIL" -> "Tentou salvar (pendências)"
    "FORM_SEND" -> when {
        detail?.contains("result=ok") == true -> "Enviou formulário"
        detail?.contains("result=fail") == true -> "Envio falhou"
        detail?.contains("result=start") == true -> "Iniciou envio"
        else -> "Enviou formulário"
    }
    "INSPECTION_UPLOAD" -> "Upload no servidor"
    "INSPECTION_UPLOAD_FAIL" -> "Upload falhou"
    "INSPECTION_DELETE" -> "Inspeção excluída"
    "INSPECTION_TRASH" -> "Inspeção → lixeira"
    "INSPECTION_RESTORE" -> "Inspeção recuperada"
    "INSPECTION_PURGE" -> "Inspeção apagada (lixeira)"
    "EMAIL_OK" -> "E-mail OK"
    "EMAIL_FAIL" -> "E-mail falhou"
    "REM_SAVE" -> "REM salvo"
    "REM_EXCEL_DOWNLOAD" -> "REM Excel baixado"
    "REM_RESET" -> "REM resetado"
    "REM_OPEN" -> "Abriu REM"
    "REM_TRASH" -> "REM → lixeira"
    "REM_RESTORE" -> "REM recuperado"
    "REM_PURGE" -> "REM apagado (lixeira)"
    "ACOMP_AMB_TRASH" -> "Acomp. Amb. → lixeira"
    "ACOMP_AMB_RESTORE" -> "Acomp. Amb. recuperado"
    "ACOMP_AMB_PURGE" -> "Acomp. Amb. apagado (lixeira)"
    "REL_SEG_SAVE" -> "Rel. Seg. salvo"
    "REL_SEG_PPTX_DOWNLOAD" -> "Rel. Seg. PPTX baixado"
    "REL_SEG_DELETE" -> "Rel. Seg. excluído"
    "REL_SEG_TRASH" -> "Rel. Seg. → lixeira"
    "REL_SEG_RESTORE" -> "Rel. Seg. recuperado"
    "REL_SEG_PURGE" -> "Rel. Seg. apagado (lixeira)"
    "PHOTO_UPLOAD" -> "Foto enviada"
    "PHOTO_UPLOAD_FAIL" -> "Upload de foto falhou"
    "PHOTO_CAPTURE_FAIL" -> "Captura de foto falhou"
    "OBRA_CREATE" -> "Obra criada"
    "OBRA_UPDATE" -> "Obra atualizada"
    "AUTH_DENIED" -> "Acesso negado"
    "app_config_update" -> "Config atualizada"
    else -> action
}
